import { createContext, useContext } from 'react'
import { type ReviewViewStore } from 'pages/reviews/store'

export const ReviewViewContext = createContext<ReviewViewStore | null>(null)

export function useReviewViewContext() {
  const context = useContext(ReviewViewContext)
  if (context === null) {
    throw new Error('You have forgotten to wrap your root component with ReviewViewContext')
  }
  return context
}
